import React, { Component, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit'
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import SaleForm from './ErtekesitesContent';
import VasarloiKartyaForm from './VasarloiKartyaForm';
import VasarloiKartyaFilter from './VasarloiKartyaFilter';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import FileSaver from 'file-saver';
import moment, { relativeTimeThreshold } from 'moment';
import { log } from 'async';
import QueryEmptyState from '../../../commons/queryempty';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';

const { ExportCSVButton } = CSVExport;

class VasarloiKartyaContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'QUERY',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formSaleStatus: 'DATA',
      
      // DATA
      baseJson: [],
      expandedItems: [],
      selectedItems:[],
      seletedActives: [],
      partnerData: [],
      szemelyData: [],
      viewObj: {},
      currentId: undefined,
      torlesId: undefined,
      aktivalasId: undefined,
      printURL: null,
      printSaleURL: null,
      aktivalas: false,
      showFilter: false,
      filters: {},
      kartyaTipus: null,

      // FORM SALE
      dataSale: [],
      selectedPrices:[],
      printAll:false,

      // MODAL UTILS
      modalView: false,
      modalDelete: false,
      modalReactivate: false,
      modalForm: false,
      modalPartner: false,
      modalSale: false,
      modalRenewal: false,
      modalCancel: false,
      formRenewal: null,
      formCancel: null,

      visibleFuncButtons: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    this.selected = false;
  }

  componentDidUpdate(prevProps) {
    if(this.props.active !== prevProps.active){
      if(this.props.active){
      this.setState({filters: {aktiv: 'AKTIV'}});
      }
      this.setState({showFilter: this.props.active});
    }
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleReactivateModal = () => {
    this.setState(prevState => ({ modalReactivate: !prevState.modalReactivate }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }), () => {
      // Nem üres a filters object (ergo lett megadva szűrési feltétel)
      if(!this.state.modalForm && !Object.keys(this.state.filters)){
        this.listVasarloiKartya(this.state.filters);
      }
    });
  }

  togglePartnerModal = () => {
    this.setState(prevState => ({ modalPartner: !prevState.modalPartner }));
  }

  toggleSaleModal = () => {
    this.setState(prevState => ({ modalSale: !prevState.modalSale }));
  }

  toggleRenewalModal = () => {
    this.setState(prevState => ({ modalRenewal: !prevState.modalRenewal }));
  }

  toggleCancelModal = () => {
    this.setState(prevState => ({ modalCancel: !prevState.modalCancel }));
  }

  onRowSelectAll = (isSelected, kartyaArray, e) => {
    const { baseJson }  = this.state;
    if(isSelected){
      this.setState(prevState => ({ selectedItems: [...prevState.selectedItems, ...this.node.filterContext.data.map(kartya => { return {
        id: kartya.id, active: kartya.aktivTulajdonos && !kartya.ervenytelenitve, printable: this.hasValue(kartya.sablonId)
      }}) ]}));
    }else{
      this.setState(prevState => ({ selectedItems: []}));
    }
  }

  onRowSelect = (kartya, isSelected, e) => {
    if(isSelected){
      this.setState(prevState => ({ selectedItems: [...prevState.selectedItems,
        { id: kartya.id, active: kartya.aktivTulajdonos && !kartya.ervenytelenitve, printable: this.hasValue(kartya.sablonId) }
       ]}));
    }else{
      this.setState(prevState => ({ selectedItems: prevState.selectedItems.filter(x => x.id != kartya.id)}));
    }
  }

  listVasarloiKartyaForm = (kartyaTipus) => {
    let filters = { ...this.state.filters, kartyaTipusId: kartyaTipus.id };
    this.listVasarloiKartya(filters);
    // Azért van megcsinálva így, mert kérés volt hogy a kártyatípus legyen beállítva a szűrők között form után, de useEffect hook miatt nem lehet filters objektumot használni
    this.setState({ filters, kartyaTipus });
  };

  listVasarloiKartya = (filters = {aktiv: 'AKTIV'}) => {
    if (!filters.kartyaTipusId) {
      this.setState({ tableStatus: 'QUERY' });
      this.props.globals.addError('Kártyatípus megadása kötelező!');
    } else {
      this.setState({
        tableStatus: 'LOAD',
        visibleActivate: false,
        visibleRenewal: false,
        filters: filters
      }, () => {
        Services.listVasarloiKartya(this.state.filters || filters, (err, res) => {
          if (!err) {
            this.setState({
              tableStatus: 'TABL',
              expandedItems: [],
              selectedItems: [],
              baseJson: res[0],
            });} 
          else if (err.responseJSON.hibaazon == "maxRowCountExceeded") {
            this.setState({
              tableStatus: 'DATA2'
            })
          } else {
            this.setState({
              tableStatus: 'NETW'
            });
          }
        });
      });
    }
  }

  getVasarloiKartyaView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.getVasarloiKartya(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  getVasarloiKartyaAr = (ids) => {
    this.setState({
      formSaleStatus: 'LOAD',
    }, () => {
      Services.getVasarloiKartyaAr(ids, (err, res) => {
        if (!err) {
          this.toggleSaleModal();
          this.setState({
            dataSale: res[0],
            printAll: false,
            formSaleStatus: 'DATA',
          }, () => {
            this.selectAllSale();
          });
        } else {
          this.toggleSaleModal();
          this.setState({
            formSaleStatus: 'NETW'
          });
        }
      });
    });
  }

  activateAzonosito = (kartyaAzon) => {
    this.setState({
      currentId: null,
      aktivalas: kartyaAzon && kartyaAzon.length > 0,
    }, () => {
    });
  }

  deActivateVasarloiKartya = () => {
    this.setState({
      deleteButtonLoading: true
    }, () => {
      Services.deActivateVasarloiKartya(this.state.torlesId, (err) => {
        if (!err) {
          this.toggleDeleteModal();
          this.listVasarloiKartya(this.state.filters);
          this.props.globals.addSuccess('Vásárlói kártya inaktiválva!');
          this.setState({
            deleteButtonLoading: false
          });
        } else {
          this.setState({
            deleteButtonLoading: false
          });
        }
      });
    });
  }

  reActivateVasarloiKartya = () => {
    this.setState({
      deleteButtonLoading: true
    }, () => {
      Services.reActivateVasarloiKartya(this.state.aktivalasId, (err) => {
        if (!err) {
          this.toggleReactivateModal();
          this.listVasarloiKartya(this.state.filters);
          this.props.globals.addSuccess('Vásárlói kártya aktiválva!');
          this.setState({
            deleteButtonLoading: false
          });
        } else {
          this.setState({
            deleteButtonLoading: false
          });
        }
      });
    });
  }

  handleExpandTulajdonosok = (cell, row) => {
    if(this.state.expandedItems.find(x => x.id == row.id)){
      this.setState({expandedItems: []});
    }else{
      this.setState({expandedItems: [{id: row.id, data: []}], tulajdonosListLoading: true});
      Services.listVasarloiKartyaTulajdonosok(row.id, (err, res) => {
        if (!err) {
          this.setState({expandedItems: [{id: row.id, data: res[0]}]});
        }
        this.setState({tulajdonosListLoading: false});
      });
    }
  }

  handleNewClick = () => {
    this.setState({
      currentId: null,
      aktivalas: false,
      selectedPrices:[],
    }, () => this.toggleFormModal());
  }

  handleEditClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
      aktivalas: false,
    }, () => {
      this.toggleFormModal();
    });
  }

  handleViewClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getVasarloiKartyaView(id, false);
      this.toggleViewModal();
    });
  }

  handleDeActivateClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleReActivateClick = (id) => {
    this.setState({
      aktivalasId: id
    }, () => {
      this.toggleReactivateModal();
    });
  }

  handlePrintClick = (id) => {
    Services.printVasarloiKartya(id, (err, res) => {
      if (!err) {
        let printURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          printURL 
        }, () => {
          window.setTimeout(() => {

            window.frames["pdf-area-vasarloikartya"].focus();
            window.frames["pdf-area-vasarloikartya"].print();
            window.setTimeout(() => {
            window.close();
            }, 50);
          }, 1000);
        })
        this.props.globals.addSuccess('Vásárlóikártya nyomtatás!');
      }
    });
  }

  selectSale = (id) => {
    const{
      dataSale,
      selectedPrices
    } = this.state;

    this.setState({ printAll: false });
    if(selectedPrices.includes(id)){
      this.setState({selectedPrices: selectedPrices.filter(x => x != id)});
    }else{
      let selectedPricesNew = [...selectedPrices, id];
      if (selectedPricesNew.length == dataSale.length)
        this.setState({ printAll: true });
      this.setState({selectedPrices: selectedPricesNew});
    }
  }

  selectAllSale = () => {
    const{
      dataSale,
      selectedPrices
    } = this.state;

    if(dataSale && selectedPrices && dataSale.length !== selectedPrices.length){
      this.setState({selectedPrices: dataSale.map(price => price.id), printAll: true});
    }else{
      this.setState({selectedPrices: [], printAll: false});
    }
  }

  handleGroupPrintClick = (query, ids, modal) => {
    const {
      filters
    } = this.state;

    const printIds = query ? this.node.filterContext.data.map(d => d.id).filter(id => this.state.selectedItems.map(s => s.id).includes(id)) : ids;
    Services.printVasarloiKartyaGroup(printIds, (err, res) => {
      if (!err) {
        let printURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          printURL
        }, () => {
          window.setTimeout(() => {
            window.frames['pdf-area-vasarloikartya-sale-group'].focus();
            window.frames['pdf-area-vasarloikartya-sale-group'].print();
            window.setTimeout(() => {
              window.close();
            }, 50);
          }, 1000);
          if (modal) {
            this.setState({ selectedItems: [] }, () => {
              this.listVasarloiKartya(filters);
              this.toggleSaleModal();
            });
          }
        });
        this.props.globals.addSuccess('Vásárlóikártya nyomtatás!');
      }
    });
  }

  handleExportClick = () => {
    Services.exportVasarloiKartyaGroup(this.state.filters, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Csv fájl letöltés indítása...');
        const blob = new Blob([res[0]], { type: 'text/csv;charset=utf-8', responseType: 'arraybuffer' });
        const date = TimeFormatter.formatDate(new Date());
        FileSaver.saveAs(blob, 'vasarloi_kartya_export_' + date + '.csv');
      }
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMDATUMA_RENEWAL':
          this.setState({ formRenewal: (moment(e).endOf('day')) });
          break;
        case 'FORMDATUMA_CANCEL':
          this.setState({ formCancel: (moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMDATUMA_RENEWAL':
          this.setState({ formRenewal: (v === '' ? null : e) });
          break;
        case 'FORMDATUMA_CANCEL':
          this.setState({ formCancel: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  renewalVasarloiKartya = () => {
    this.setState({
      saveButtonLoading: true
    }, () => {
      const renewalDate = this.state.formRenewal ? TimeFormatter.formatIso(this.state.formRenewal) : null;
      const ids = this.node.filterContext.data.map(d => d.id).filter(id => this.state.selectedItems.map(s => s.id).includes(id));;
      Services.renewalVasarloiKartya(ids, renewalDate, (err) => {
        if (!err) {
          this.toggleRenewalModal();
          this.props.globals.addSuccess('Vásárlóikártyák meghosszabbítva!');
          this.setState({
            saveButtonLoading: false,
            formRenewal: null
          }, () => this.listVasarloiKartya(this.state.filters));
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    });
  }

  cancelVasarloiKartya = () => {
    this.setState({
      saveButtonLoading: true
    }, () => {
      const cancelDate = this.state.formCancel ? TimeFormatter.formatIso(this.state.formCancel) : null;
      const ids = this.node.filterContext.data.map(d => d.id).filter(id => this.state.selectedItems.map(s => s.id).includes(id));;
      Services.cancelVasarloiKartya(ids, cancelDate, (err) => {
        if (!err) {
          this.toggleCancelModal();
          this.props.globals.addSuccess('Vásárlóikártyák érvénytelenítve!');
          this.setState({
            saveButtonLoading: false,
            formCancel: null
          }, () => this.listVasarloiKartya(this.state.filters));
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    });
  }

  isDate = (date) => {
    return date instanceof Date && !isNaN(date.valueOf());
  }

  hasValue = (value) => {
    return value || value === 0;
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          <Button className="icon-list table-action-icon" id={'action-view-' + cell + 'tulajdonosok'} onClick={() => this.handleExpandTulajdonosok(cell, row)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'tulajdonosok'} delay={50}>
            {'Tulajdonosok'}
          </UncontrolledTooltip>
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment> 
        {this.props.globals.hasRole(['KEDVEZMENY_VK'], true) && (
          <React.Fragment>
          {row && row.aktiv && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
            
          {row && this.hasValue(row.sablonId) && (
            <React.Fragment>
              <Button className="icon-printer table-action-icon" id={'action-view-' + cell + 'print'} onClick={() => this.handlePrintClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'print'} delay={50}>
                {'Nyomtatás'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          </React.Fragment>
        )}
        {row && row.hasznalhato && this.props.globals.hasRoleSpec(['KEDVEZMENY_VK_TORL']) && (
        <React.Fragment>
          <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeActivateClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
            {'Inaktiválás'}
          </UncontrolledTooltip>
        </React.Fragment>
        )}
        {row && !row.hasznalhato && this.props.globals.hasRoleSpec(['KEDVEZMENY_VK_ADMIN']) && (
          <React.Fragment>
          <Button className="icon-action-undo table-action-icon" id={'action-view-' + cell + 'reactivate'} onClick={() => this.handleReActivateClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'reactivate'} delay={50}>
            {'Újrafelhasználhatóvá tétel'}
          </UncontrolledTooltip>
        </React.Fragment>
        )}
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <b>Azonosító/sorszám: </b>
        <Button type="button" outline color={viewObj && viewObj.aktiv ? "success" : "secondary"} disabled >
          {viewObj && viewObj.azonosito}
        </Button>
        <br />
        <b>Kártya típusa: </b>
        {viewObj && viewObj.kartyaTipus && viewObj.kartyaTipus.nev}
        <br />
        { viewObj && viewObj.aktiv && (
          <React.Fragment>
            <b>Helyszín: </b>
            {viewObj && viewObj.aktiv && viewObj.aktiv.helyszin && viewObj.aktiv.helyszin.nev}
            <br />
            <b>Tulajdonos: </b>
            {viewObj && viewObj.aktiv && viewObj.aktiv.tulajdonos && viewObj.aktiv.tulajdonos.nev}
            <br />
            <b>Érvényesség kezdete: </b>
            {viewObj && viewObj.aktiv && viewObj.aktiv.kezdete && TimeFormatter.formatDateTime(viewObj.aktiv.kezdete)}
            <br />
            <b>Érvényesség vége: </b>
            {viewObj && viewObj.aktiv && viewObj.aktiv.vege && TimeFormatter.formatDateTime(viewObj.aktiv.vege)}
            <br />
            <b>Érvénytelenítés: </b>
            {viewObj && viewObj.aktiv && viewObj.ervenytelenites && TimeFormatter.formatDateTime(viewObj.ervenytelenites)}
            <br />
            <b>Ár: </b>
            {viewObj && viewObj.aktiv && viewObj.aktiv.ar || ""}
            <br />
            <b>Megjegyzés: </b>
            {viewObj && viewObj.aktiv && viewObj.aktiv.megjegyzes}
          </React.Fragment>
        )}
        <br />
        <b>Csere: </b>
        {(viewObj && viewObj.csere) ? "Igen" : "Nem"}
        <br />
        <b>Cserélt azonosító: </b>
        {viewObj && viewObj.cserelt && viewObj.cserelt.azonosito}
        <br />
        <b>Aktiválva: </b>
        {viewObj && (viewObj.uvd && viewObj.uvd.rogzszemelynev)  + ": " + TimeFormatter.formatDateTime(viewObj.rogzidopont)}
      </div>
    );
  }

  renderSelectedFuncButtons = (start, to, total) => {
    const {
      selectedItems,
    } = this.state;
    
    const activeButtonsVisible = selectedItems.length > 0 && selectedItems.every(x => x.active);
    const printableButtonsVisible = selectedItems.length > 0 && selectedItems.some(x => x.printable );
    return(
        <span>
          {' '}
          <Button className="text-black" >
            { start } - { to } / { total } tétel megjelenítése
          </Button>
          {' '}
          {activeButtonsVisible && (
            <React.Fragment>
              { printableButtonsVisible &&
                <Button type="button" color="success" style={{marginTop: '3px'}} onClick={() => this.handleGroupPrintClick(true, selectedItems.map(x => x.id))}>
                    {'Nyomtatás'}
                </Button>
              }
              {' '}
              {this.props.globals.hasRoleSpec(['KEDVEZMENY_VK_ADMIN']) &&
                <React.Fragment>
                  <Button type="button" color="success" style={{marginTop: '3px'}} onClick={() => this.toggleRenewalModal()}>
                      {'Meghosszabbítás'}
                  </Button>
                  {' '}
                  <Button type="button" color="success" style={{marginTop: '3px'}} onClick={() => this.toggleCancelModal()}>
                      {'Érvénytelenítés'}
                  </Button>
                </React.Fragment>
              }
            </React.Fragment>
          )}
        </span>
    );
  }

  renderTable = () => {
    let options = {...Lib.bootstraptableProps};
    options.paginationTotalRenderer = this.renderSelectedFuncButtons;

    const selectRow = {
      selected: this.state.selectedItems.map(x => x.id),
      mode: 'checkbox',
      clickToSelect: false,
      onSelect: this.onRowSelect,
      onSelectAll: this.onRowSelectAll,
      style: { backgroundColor: '#c8e6c9' },
    }

    const formatterAktivalva = (cell) => {
      let aktivalvaArray = cell.split("|");
      return aktivalvaArray[0] + " : " + TimeFormatter.formatDateTime(aktivalvaArray[1]);
    }

    const columns = [
      {
        dataField: 'kartyaTipus.nev',
        text: 'Kártya típusa',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Vásárlói kártya sorszáma',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'aktiv.kartyabirtokos',
        text: 'Kártyabirtokos',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        csvFormatter: cell => cell || ''
      },
      {
        dataField: 'aktiv.ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        csvFormatter: cell => cell || ''
      },
      {
        dataField: 'csoport',
        text: 'Csoport azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        csvFormatter: cell => cell || ''
      },
      {
        dataField: 'aktivalva',
        text: 'Aktiválva',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter:  cell => formatterAktivalva(cell)
      },
      {
        dataField: 'csere',
        text: 'Csere',
        hidden: true,
        csvFormatter: cell => cell ? 'Igen' : 'Nem'
      },
      {
        dataField: 'cserelt',
        text: 'Cserélt',
        hidden: true,
        csvFormatter: cell => cell || ''
      },
      {
        dataField: 'aktiv.fizmod',
        text: 'Fizetési mód',
        hidden: true,
        csvFormatter: cell => (cell && cell.nev) || ''
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        csvExport: false,
        formatter: this.tableIconFormatter
      }
    ];

    const tulajdonosColumns = [
      {
        dataField: 'tulajdonos.nev',
        text: 'Tulajdonos',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'helyszin.nev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'fizmod.nev',
        text: 'Fizetési mód',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'ervenyesseg',
        text: 'Érvényesség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'ar',
        text: 'Ár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell
      }
    ];

    const expandRow = {
    renderer: row => ( this.state.expandedItems.find(x => x.id == row.id) &&
          <React.Fragment>
            <div className="row">
              <div className="col-md-2">
                <h5>Tulajdonosok</h5>
              </div>  
            </div>
            {this.state.tulajdonosListLoading && <Loader />}
            {!this.state.tulajdonosListLoading &&
              <BootstrapTable
                bootstrap4
                keyField="id"
                data={this.state.expandedItems.find(x => x.id == row.id).data}
                columns={tulajdonosColumns}
                filter={filterFactory()}
                noDataIndication="A kártya még nem került aktiválásra!"
              />
            }
          </React.Fragment>
      ),
      expanded: this.state.expandedItems.map( x => x.id),
      expandByColumnOnly: true,
    };

    return (
        <div className="animated fadeIn">
          <ToolkitProvider
            exportCSV={{
              onlyExportFiltered: true,
              exportAll: false,
              fileName: 'vasarloi_kartya.csv',
              separator: ';',
              blobType: "application/csv;charset=utf-8",
              noAutoBOM: false
            }}
            keyField="id"
            data={this.state.baseJson}
            columns={columns}
          >
          {props => (
            <React.Fragment>
              {this.renderButtons()}
              <BootstrapTable
                {...props.baseProps }
                ref={ n => this.node = n }
                bootstrap4
                keyField="id"
                data={this.state.baseJson}
                expandRow={expandRow}
                selectRow={selectRow}
                //rowClasses="kartya-row-class" 
                columns={columns}
                filter={filterFactory()}
                pagination={paginationFactory(options)}
                noDataIndication="Nincs megjelenítendő adat!"
              />
            </React.Fragment>
          )}
          </ToolkitProvider>
        </div>
    );
  }
  
  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          DATA2: (<QueryEmptyState
            hasImage
            title="Túl nagy eredményhalmaz"
            subtitle="Próbálj szigorúbb előszűrést alkalmazni!"
          />),
          QUERY: (<QueryEmptyState hasImage />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listVasarloiKartya(this.state.filters)}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderModals = () => {
    return(
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Inaktiválás</ModalHeader>
          <ModalBody>Valóban inaktiválni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deActivateVasarloiKartya()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getVasarloiKartyaView(this.state.currentId)}
              />),
              DATA: (this.renderView())
            }[this.state.viewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalReactivate} toggle={this.toggleReactivateModal} backdrop="static">
          <ModalHeader>Újrafelhasználhatóvá tétel</ModalHeader>
          <ModalBody>Valóban szeretnéd újrafelhasználhatóvá tenni a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.reActivateVasarloiKartya()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleReactivateModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalSale} toggle={this.toggleSaleModal} backdrop="static">
          <RFForm
            modal
            onSubmit={() => { this.listVasarloiKartya(this.state.filters); this.toggleSaleModal(); }}
            tagProps={{ tag: () => PrintHeader(), className: 'no-gutters', style: { width: '100%' } }}
            footer={
              <>
                <Button type="button" color="primary" className="pull-right" onClick={() => this.selectAllSale()}> 
                  <span>{this.state.printAll ? "Kijelölés megszüntetése" : "Összes kijelölése"}<i aria-hidden="true"></i></span>
                </Button>
                <Button type="button" color="primary" className="btn-cursor-pointer" onClick={() => this.handleGroupPrintClick(false, this.state.selectedPrices)} disabled={this.state.selectedPrices && this.state.selectedPrices.length == 0}>
                  Nyomtatás
                </Button>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.listVasarloiKartya(this.state.filters); this.toggleSaleModal(); }}>
                  Vissza
                </Button>
              </>
            }
          >
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getVasarloiKartyaAr(this.state.currentId)}
              />),
              DATA:
                <SaleForm
                  selectedPrices={this.state.selectedPrices}
                  selectSale={this.selectSale}
                  dataSale={this.state.dataSale} 
                />
            }[this.state.formSaleStatus]}
          </RFForm>
        </Modal>

        <Modal isOpen={this.state.modalRenewal} toggle={this.toggleRenewalModal} backdrop="static">
          <RFForm 
          modal
          onSubmit={this.renewalVasarloiKartya}
          title="Kiválasztottak meghosszabbítása"
          footer={
            <>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleRenewalModal}>Mégsem</Button>
            </>
          }
          >
            <DatetimePicker
              label={'Dátuma: '}
              id={"formRenewal"}
              name={"formRenewal"}
              containerClassName="organw-date-time"
              time={true}
              // format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum" , timeButton: "idő"}}
              value={this.state.formRenewal && new Date(this.state.formRenewal)}
              // onChange={(e,v) => this.handleDateInputChange(e, v, "formRenewal")}
              onChange={(e,v) => {this.handleDateChange(e,v,'FORMDATUMA_RENEWAL')}} 
              onSelect={(e,v) => { this.selected = true }}
              timePrecision="seconds"
            />
          </RFForm>
        </Modal>

        <Modal isOpen={this.state.modalCancel} toggle={this.toggleCancelModal} backdrop="static">
          <RFForm 
            modal
            onSubmit={this.cancelVasarloiKartya}
            title="Kiválasztottak érvénytelítése"
            footer={
              <>
                <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleCancelModal}>Mégsem</Button>
              </>
            }
          >
            <DatetimePicker
              label={'Dátuma: '}
              id={"formCancel"}
              name={"formCancel"}
              containerClassName="organw-date-time"
              time={true}
              // format="YYYY-MM-DD HH:mm:ss"
              messages={{ dateButton: "dátum" , timeButton: "idő"}}
              value={this.state.formCancel && new Date(this.state.formCancel)}
              // onChange={(e,v) => this.handleDateInputChange(e, v, "formCancel")}
              onChange={(e,v) => {this.handleDateChange(e,v,'FORMDATUMA_CANCEL')}} 
              onSelect={(e,v) => { this.selected = true }}
              timePrecision="seconds"
            />
          </RFForm>
        </Modal>
    </React.Fragment>
    );
  }
  
  renderButtons = () => {
    return(
      <div>
        {this.props.globals.hasRole(['KEDVEZMENY_VK'], true) && (
          <Button type="button" className="pull-left table-new-button" style={{verticalAlign: 'top', marginRight: '5px'}} color="primary" onClick={this.handleNewClick}>
            {'Új vásárlói kártya'}
          </Button>
        )}
        <Button type="button" style={{verticalAlign: 'top', marginLeft: '50px', marginRight: '5px'}} color="primary" onClick={() => this.listVasarloiKartya(this.state.filters)}> 
          <span><i className="fa fa-search" aria-hidden="true"></i></span>
        </Button>
        {this.props.globals.hasRole(['KEDVEZMENY_VK'], true) && (
          <Button type="button" style={{verticalAlign: 'top', marginRight: '5px'}} color="success" onClick={() => this.handleExportClick(this.state.filters)}>
            <span><i className="fa fa-download" aria-hidden="true"></i></span>
          </Button>
        )}
        {/* <ExportCSVButton  {...props.csvProps }>
          <span><i className="fa fa-download" aria-hidden="true"></i></span>
        </ExportCSVButton> */}
      </div>
    );
  }

  render = () => {
    const {
      aktivalas,
      printURL,
      showFilter,
      modalForm,
      tableStatus,
    } = this.state;
    return (
      <React.Fragment>
        <iframe name="pdf-area-vasarloikartya" id="pdf-area-vasarloikartya" src={printURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
        <iframe name="pdf-area-vasarloikartya-sale-group" id="pdf-area-vasarloikartya-sale-group" src={printURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
        {showFilter && <VasarloiKartyaFilter setFilter={filters => this.setState({filters: filters})} kartyaTipus={this.state.kartyaTipus} />}
        {tableStatus != 'TABL' && this.renderButtons()}
        <div className="row">
          {this.renderTableView()}
        </div>
        {this.renderModals()}
        {modalForm && 
          <VasarloiKartyaForm
            globals={this.props.globals}
            id={this.state.currentId}
            aktivalas={aktivalas}
            modositas={!!this.state.currentId}
            activateAzonosito={this.activateAzonosito}
            loadVasarloiKartyaPrint={this.getVasarloiKartyaAr}
            toggleFormModal={this.toggleFormModal}
            listVasarloiKartyaForm={this.listVasarloiKartyaForm}
          />
        }
      </React.Fragment>
    );
  }
}

const PrintHeader = () => {
  return (
    <div className="col-md-12">
      <div style={{fontWeight: 500, lineHeight: 1.2, fontSize: "1.25rem"}}>Értékesítés</div>
    </div>
  );
}

VasarloiKartyaContent.propTypes = {
  globals: PropTypes.object
};

export default VasarloiKartyaContent;
